if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains('quick-view-modal__content')) {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}